module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.3200/images/highlightedMembers/katherine-boyarsky.png"